import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import { styled } from "@mui/system";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { ROUTE_BROWSE_JOBS_NEW, ROUTE_MAIN, ROUTE_COMPLETE_PROFILE } from "../../constants/routes";
import { Search,  } from "@mui/icons-material";
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import { logoutClear } from "../../redux/actions/appActions";
import { useDispatch } from "react-redux";
import NotificationNavButton from "./NotificationNavButton";

const CssTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
    },
    "&:hover fieldset": {
      border: "none",
    },
    "&.Mui-focused fieldset": {
      border: "none",
    },
  },
  "& input": {
    border: "none",
    borderRadius: "99px",
    padding: "10px 10px",
  },
  "& input::placeholder": {
    color: "black",
  },
}));

const Header = styled("header")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "left",
  padding: "20px",
}));

const Logo = styled("img")({
  aspectRatio: "1.89",
  width: "75px",
});

const SeeviHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const Logout = () => {
    dispatch(logoutClear(()=>{
        navigate(ROUTE_MAIN, { replace: true });
        
    }));
    // localStorage.clear(); // Clear the token
    // navigate('/'); // Redirect to home
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "rgb(255, 137, 96)",
        justifyContent: "space-between",
        alignItems: "center",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <Header onClick={() => navigate(ROUTE_COMPLETE_PROFILE)}>
        <Logo src="/images/client-website/seevi-logo.png" alt="Logo" />
      </Header>
      <Box sx={{ mb: 1, mr: 1 }} onClick={() => navigate(ROUTE_BROWSE_JOBS_NEW)}>
        <CssTextField
          id="outlined-number"
          placeholder="Browse Jobs"
          variant="outlined"
          sx={{ width: "180px", mt: 1 }}
          InputProps={{
            style: {
              borderRadius: "99px",
              backgroundColor: "#ffffff",
            },
            inputProps: {
              sx: {
                padding: "10px 0px 10px 20px !important", // ✅ Remove right padding while keeping vertical padding
              },
            },
            endAdornment: (
              <InputAdornment position="end" style={{ color: "#756DE9" }}>
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box sx={{ mt: 0, mr: 1, display: "flex", alignItems: "center" }}>
        <NotificationNavButton iconColor="#fff" />
      </Box>
      <Box sx={{ mt: 0, mr: 2 }} onClick={() => navigate(ROUTE_COMPLETE_PROFILE)} style={{ cursor: "pointer" }}>
           <InputAdornment position="end" style={{ color: "#fff", width: 20, height: 50}}>
                <HomeIcon  />
              </InputAdornment> 
      </Box>
      <Box sx={{ mt: 0, mr: 2 }} onClick={() => Logout()} style={{ cursor: "pointer" }}>
           <InputAdornment position="end" style={{ color: "#fff", width: 20, height: 50}}>
                <LogoutIcon  />
              </InputAdornment> 
      </Box>
    </Box>
  );
};

export default SeeviHeader;
